export default __webpack_public_path__ + "83c5aae275d81ac5ec4a8adccbc0babd.woff2";